import { render, staticRenderFns } from "./v-scroll-to.vue?vue&type=template&id=16263751&"
import script from "./v-scroll-to.vue?vue&type=script&lang=js&"
export * from "./v-scroll-to.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports